import axios from "axios";
require("dotenv").config();

const path = process.env.REACT_APP_API_URL;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

function getDomainName() {
  const url = window.location.href;
  let domain = new URL(url);
  domain = domain.hostname;
  console.log(domain);

  if (process.env.REACT_APP_MODE === "production") {
    domain = domain.replace("www.", "");
    return domain;
  } else {
    // let s = localStorage.getItem("settings");
    // console.log(s);
    // s = s ? JSON.parse(s) : s;
    return "courier";
  }
}

// ADD A REQUEST INTERCEPTOR
axios.interceptors.request.use(
  (config) => {
    console.log(config);
    config.baseURL = path;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//ADD A RESPONSE INTERCEPTOR
axios.interceptors.response.use(
  (response) => {
    console.log("failed 13");
    return response;
  },
  async (error) => {
    console.log(error);
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      originalRequest.url === getDomainName() + "/oauth/token"
    ) {
      console.log("failed 11");
      localStorage.clear();
      window.location = "/";
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      let refreshToken = localStorage.getItem("wRefreshToken");
      console.log(refreshToken);

      return new Promise(function (resolve, reject) {
        axios
          .post(getDomainName() + "/oauth/token", {
            client_id: "3",
            client_secret: "msndncuyftbegfnwteyufbtwefytewbufgwwye",
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            provider: "customers",
          })
          .then(async ({ data }) => {
            console.log(data);
            localStorage.setItem("wAccessToken", data.access_token);
            localStorage.setItem("wRefreshToken", data?.refresh_token);
            let now = (Date.now() / 1000) | 0;
            localStorage.setItem("wExpiresIn", now + data.expires_in);

            axios.defaults.headers.common["Authorization"] =
              "Bearer " + data?.access_token;
            originalRequest.headers["Authorization"] =
              "Bearer " + data?.access_token;
            processQueue(null, data?.access_token);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);
